/**
 * analytics.js — helper centralizado GA4 + Meta Pixel
 *
 * Uso:
 *   import analytics from '@/services/analytics';
 *   analytics.purchase({ value: 29.99, currency: 'EUR', transaction_id: 'pi_xxx', item_name: 'VIP' });
 */

function gtag(...args) {
  if (typeof window.gtag === 'function') {
    window.gtag(...args);
  } else if (window.dataLayer) {
    // GTM sin gtag directo: empuja el evento igualmente
    window.dataLayer.push(args);
  }
}

function fbq(event, params = {}, eventId = null) {
  if (typeof window.fbq === 'function') {
    if (eventId) {
      window.fbq('track', event, params, { eventID: eventId });
    } else {
      window.fbq('track', event, params);
    }
  }
}

const analytics = {
  // Llamado desde el router en afterEach
  pageView({ page_path, page_title } = {}) {
    gtag('event', 'page_view', {
      page_path:  page_path  || window.location.pathname,
      page_title: page_title || document.title,
    });
  },

  // Registro completado
  signUp() {
    gtag('event', 'sign_up', { method: 'email' });
    fbq('CompleteRegistration');
  },

  // Login completado
  login() {
    gtag('event', 'login', { method: 'email' });
  },

  // Usuario hace clic en "Suscribirse" antes de ver el formulario de pago
  addToCart({ item_name, value, currency = 'EUR' } = {}) {
    gtag('event', 'add_to_cart', {
      currency,
      value,
      items: [{ item_name }],
    });
  },

  // Formulario de pago de Stripe ya visible
  beginCheckout({ item_name, value, currency = 'EUR' } = {}) {
    gtag('event', 'begin_checkout', {
      currency,
      value,
      items: [{ item_name }],
    });
  },

  // Pago completado con éxito
  purchase({ value = 0, currency = 'EUR', referencia = null } = {}) {
    // GA4
    if (value > 0) {
      gtag('event', 'purchase', {
        transaction_id: referencia || '',
        value,
        currency,
      });
    }
    // Meta Pixel
    const metaParams = value > 0 ? { value, currency } : {};
    const eventId = referencia ? 'QTY_PURCHASE_' + referencia : null;
    fbq('Purchase', metaParams, eventId);
  },

  // Usuario se une a un canal gratuito (embudo principal de Quanty)
  generateLead({ tipster, channel_name } = {}) {
    gtag('event', 'generate_lead', { tipster, channel_name });
    fbq('Lead', { tipster, channel_name });
  },

  // Error en el proceso de pago Stripe
  checkoutError({ error_code, item_name } = {}) {
    gtag('event', 'checkout_error', { error_code, item_name });
  },

  // Visita a landing de campaña
  viewLanding({ landing_slug, tipster, utm_source, utm_campaign } = {}) {
    gtag('event', 'view_landing', { landing_slug, tipster, utm_source, utm_campaign });
  },

  // Click en CTA de landing
  ctaClick({ landing_slug, cta_label, tipster } = {}) {
    gtag('event', 'cta_click', { landing_slug, cta_label, tipster });
  },

  // Cancelación de suscripción
  subscriptionCancelled({ item_name, tipster, value, currency = 'EUR' } = {}) {
    gtag('event', 'subscription_cancelled', { item_name, tipster, value, currency });
  },
};

export default analytics;
